module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Crossbow_C.5cfc78bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Crossbow_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_Crossbow_C.png
// module chunks = 0